import { Log } from '@/parsing/Log';
import { LogEntry, LogEntryType } from '@/parsing/LogEntry';

import { TimelineMarker, TimelineRow, TimelineRowGroup } from '../../TimelineData';
import { addTimeSpanMarker } from '../addTimeSpanMarker';
import { obtainFreeRowForMarker } from '../obtainFreeRowForMarker';
import { TimelineGeneratorContext } from '../TimelineGeneratorContext';

export function generateAndroidAppStateGroupFromLog(
  log: Log,
  ctx: TimelineGeneratorContext,
): TimelineRowGroup {
  const appIsActiveRow: TimelineRow = { markers: [] };
  const rows: TimelineRow[] = [];

  let appBecameActiveEntry: LogEntry | undefined;
  let appResignActiveEntry: LogEntry | undefined;

  for (const entry of log.entries) {
    if (entry.entryType !== LogEntryType.Generic) {
      continue;
    }

    const tooltipContent = entry.content;
    let textOnMarker = '';
    let fillColor = '';

    if (entry.content.startsWith('Application started')) {
      textOnMarker = 'Active';
      fillColor = '#3eff37';
      appBecameActiveEntry = entry;
    } else if (entry.content.startsWith('Application stopped')) {
      textOnMarker = 'Inactive';
      fillColor = '#effc4c';
      if (appBecameActiveEntry) {
        appResignActiveEntry = entry;
      }
    } else {
      continue;
    }

    const marker: TimelineMarker = {
      markerId: ctx.nextMarkerId,
      logEntry: entry,
      startTimeMs: entry.date.getTime(),
      endTimeMs: undefined,
      fillColor,
      textOnMarker,
      textOnMarkerColor: undefined,
      tooltipContent,
    };
    ctx.nextMarkerId += 1;

    const row = obtainFreeRowForMarker(rows, marker);
    row.markers.push(marker);

    if (appBecameActiveEntry && appResignActiveEntry) {
      addAppIsActiveSpanTimeMarker({
        startEntry: appBecameActiveEntry,
        endEntry: appResignActiveEntry,
        endTimeMs: appResignActiveEntry.date.getTime(),
        appIsActiveRow,
        ctx,
      });

      appBecameActiveEntry = undefined;
      appResignActiveEntry = undefined;
    }
  }

  const lastEntryTimeMs = log.entries[log.entries.length - 1].date.getTime();

  if (appBecameActiveEntry) {
    addAppIsActiveSpanTimeMarker({
      startEntry: appBecameActiveEntry,
      endEntry: undefined,
      endTimeMs: lastEntryTimeMs,
      appIsActiveRow,
      ctx,
    });
    appBecameActiveEntry = undefined;
  }

  const rowGroup: TimelineRowGroup = {
    name: 'Application state',
    rows,
    expanded: true,
  };

  if (appIsActiveRow.markers.length > 0) {
    rowGroup.rows.splice(0, 0, appIsActiveRow);
  }

  return rowGroup;
}

function addAppIsActiveSpanTimeMarker(args: {
  startEntry: LogEntry;
  endEntry: LogEntry | undefined;
  endTimeMs: number;
  appIsActiveRow: TimelineRow;
  ctx: TimelineGeneratorContext;
}) {
  addTimeSpanMarker({
    startEntry: args.startEntry,
    endEntry: args.endEntry,
    endTimeMs: args.endTimeMs,
    row: args.appIsActiveRow,
    ctx: args.ctx,
    fillColor: '#ecc9f3',
    textOnMarker: `App is active`,
    textOnMarkerColor: '#571d5b',
    tooltipContent: `Application was active during this time span`,
  });
}
